module.exports = __webpack_public_path__ + "static/media/task.9be3623a.svg";